import _ from "lodash"
import { InputContainer } from "../../../../../../common/components/form/input/containers/input.container";



export const OnboardAuthorisedSignatoryInfoComponent = ({ handleFormAuthorizedSignatoryItemChange,authorizedSignatory }: any) => {
    return (
<>
{ _.map(
  authorizedSignatory,
  (selectedKeywords: any, itemIndex: any) => (
                      <div className=" py-4 border-b">
                        <div className=" grid md:grid-cols-3 lg:grid-cols-4 gap-4">
                        <InputContainer
          label="Name of Authorized Signatory"

          onValueChange={(event: any, newValue: any) => {
            handleFormAuthorizedSignatoryItemChange({
              value: event.target.value,
              field: 'NameOfAuthorisedSignatory',
              idx: itemIndex
            });
          }}
          type="text"
          value={selectedKeywords?.NameOfAuthorisedSignatory}

      />

<InputContainer
          label="Email Address"

          onValueChange={(event: any, newValue: any) => {
            handleFormAuthorizedSignatoryItemChange({
              value: event.target.value,
              field: 'EmailAddress',
              idx: itemIndex
            });
          }}
          type="text"
          value={selectedKeywords?.EmailAddress}

      />
      <InputContainer
          label="Mobile Number"

          onValueChange={(event: any, newValue: any) => {
            handleFormAuthorizedSignatoryItemChange({
              value: event.target.value,
              field: 'MobileNumber',
              idx: itemIndex
            });
          }}
          type="text"
          value={selectedKeywords?.MobileNumber}

      />
      <InputContainer
          label="Designation"

          onValueChange={(event: any, newValue: any) => {
            handleFormAuthorizedSignatoryItemChange({
              value: event.target.value,
              field: 'Designation',
              idx: itemIndex
            });
          }}
          type="text"
          value={selectedKeywords?.Designation}

      />
      <InputContainer
          label="Aadhar Number"

          onValueChange={(event: any, newValue: any) => {
            handleFormAuthorizedSignatoryItemChange({
              value: event.target.value,
              field: 'AadharNumber',
              idx: itemIndex
            });
          }}
          type="text"
          value={selectedKeywords?.AadharNumber}

      />
      <InputContainer
  label="Attachments"
  name="Udhyam Registered Certificate"
  onValueChange={(newValue: any) => {
    const ipaddressData: any = newValue.map((option: any) => option?.id)
    handleFormAuthorizedSignatoryItemChange({
      value:ipaddressData,
      field: 'Attachments',
      idx: itemIndex
    });
  }}
  type="multiselectText"
  value={selectedKeywords?.Attachments}
  />
     
                        </div>
                        </div>
  ))}
  </>
    )
}